<template>
    <t-space e direction="vertical" align="start" style="width: 100%;">
        <t-space style="width: 100%;"></t-space>
        <t-space direction="horizontal">
            <t-space></t-space>
            <t-card title="库存调拨单据" style="width: 85.5vw;">
                <t-space direction="vertical">
                    <t-button @click="()=>{ showAddDialog = true }">新增供应商/客户</t-button>
                    <t-table
                        row-key="index"
                        :data="tableData"
                        cell-empty-content="-"
                        :pagination="pageConfig"
                        :columns="columns">
                    </t-table>
                </t-space>
            </t-card>
        </t-space>
    </t-space>
</template>

<script lang="jsx" setup>
import request from '@/request/request';
import { NotifyPlugin } from 'tdesign-vue-next';
import { onMounted, ref } from 'vue';

console.log(request)
console.log(NotifyPlugin)
console.log(onMounted)

const pageConfig = ref({
    pageSize: 8, 
    defaultCurrent: 1, 
    defaultPageSize: 8,
    total: 100,
    showPageSize: false,
    onCurrentChange: (number)=>{
        console.log(number)
    }
})

</script>

<style scoped>
</style>